export const RouteConfig = {
  login: {
    name: "登录",
    path: "/login"
  },
  home: {
    name: "首页",
    path: "/"
  },
  sceneList: {
    name: "场景管理",
    path: "/scene/list"
  },
  sceneDetail: {
    name: "场景详情",
    path: "/scene/detail/:id"
  },
  userManagement: {
    name: "用户管理",
    path: "/user/list"
  },
  userFeedbackPage: {
    name: "用户反馈",
    path: "/user/feedback"
  },
  systemConfigPage: {
    name: "系统配置",
    path: "/system/config"
  },
  appUpdatePage: {
    name: "App更新配置",
    path: "/system/app-update"
  },
  modulePage: {
    name: "模块管理",
    path: "/module/list"
  },
  paymentOrderPage: {
    name: "支付订单",
    path: "/payment/orders"
  },
  paymentStatisticsPage: {
    name: "支付统计",
    path: "/payment/statistics"
  },
  taskPage: {
    name: "任务管理",
    path: "/task/list"
  },
  videoMultiAudio: {
    name: "视频多角色语音",
    path: "/video/multi-audio"
  },
}
